<template>
	<v-main id="onboarding-container">
		<div v-if="isLoggedIn" class="buttons-container">
			<v-btn v-if="displayCancelButton" text @click="cancelNewOrganization()">
				<v-icon class="mr-1">mdi mdi-close</v-icon>
				Cancel
			</v-btn>

			<v-btn text @click="logout">
				<v-icon class="mr-1">mdi mdi-logout</v-icon>
				Log Out
			</v-btn>
		</div>

		<v-row class="content">
			<v-col sm="4" class="sidebar">
				<v-img class="logo" :src="require('@/assets/logo.png')" />
			</v-col>

			<v-col class="main d-flex flex-column justify-center align-center py-15" sm="8" cols="12">
                <img class="onboarding-logo" src="/assets/media/images/site-logo-black-white-bg.png" />
                <router-view />
			</v-col>
		</v-row>
	</v-main>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
	computed: {
		...mapGetters("User", ["isLoggedIn"]),
		...mapState("User", ["user"]),
		displayCancelButton() {
			if (!this.$route.meta.displayCancelButton) return false;
			if (this.user.accounts.length == 1 && this.user.accounts[0].role_id == 2) return false;
			else return true;
		},
	},
	methods: {
		logout() {
			this.$router.push({ name: "signout" });
		},

		async cancelNewOrganization() {
			this.$store.dispatch("Auth/unsetActiveAccount");
			// await this.$store.dispatch("User/fetchUser");
			vm.$router.go();
		},
	},
};
</script>

<style lang="scss" scoped>
#onboarding-container {
	position: relative;

    * {
        font-family: Poppins !important;
    }

    ::v-deep .v-input {
        .v-label {
            color: #7e7e7e;
        }
    }

    ::v-deep .v-btn__content {
        font-weight: 700;
    }

	.buttons-container {
		position: absolute;
		top: 10px;
		right: 10px;
		z-index: 99;
	}

	.content {
		height: 100%;
        margin: 0;

        .sidebar {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
            background-color: #121212;
            @media (max-width: 575px) {
                display: none;
            }

            .logo {
                max-width: 40%;
            }
        }

        .main {
            height: 100%;
            background-color: white;
        }
	}
}
</style>

<style lang="scss">
.onboarding-logo {
    width: 80px;
    margin: 0 auto;
    display: block;
}

.onboarding-title {
    font-size: 22px;
    font-weight: 600;
    line-height: 1.25;
}

.onboarding-subtitle {
    font-size: 14px;
    color: #666;
    line-height: 1.25;
}

.narrow-container {
    max-width: 530px;
}

.onboarding-text,
.onboarding-link {
    color: #666 !important;
    font-size: 14px;
}

.onboarding-text {
    line-height: 1.25;
}

.onboarding-link {
    text-decoration: underline;
}

.v-select-list {
    box-shadow: 0 0 0 0 rgb(0 0 0 / 10%), 0 0 0 0 rgb(0 0 0 / 7%), 0 0 0 0 rgb(0 0 0 / 6%) !important;

    .v-list-item__title {
        font-family: Poppins;
        font-size: 14px;
        color: #666;
    }
}
</style>
